import {Component, ElementRef, Input, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {PackagingLabel} from '../../../../../Models/PackagingLabel';
import {environment} from '../../../../../../../environments/environment';
import {ServiceRequestService} from '../../../../../Services/service-request.service';
import {ServiceRequest} from '../../../../../Models/ServiceRequest';

@Component({
  selector: 'app-reply-step-packaging-label',
  templateUrl: './reply-step-packaging-label.component.html',
  styleUrls: ['./reply-step-packaging-label.component.scss']
})
export class ReplyStepPackagingLabelComponent implements OnInit {

  @Input() Index;
  @Input() isActive;
  @ViewChild('generateModal', {static: false}) generateModal;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  public dealer;
  public replyItem;
  public serviceRequest: ServiceRequest = new ServiceRequest();
  public baseUrl = environment.apiUrl;
  public packagingLabel = new PackagingLabel();

  constructor(private requestService: ServiceRequestService) {
  }

  ngOnInit() {
    this.requestService.serviceRequest.subscribe(serviceRequest => {
      if (serviceRequest.reply.replyItems[this.Index]) {
        this.serviceRequest = serviceRequest;
        this.serviceRequest.reply.replyItems = serviceRequest.reply.replyItems.filter(item => !item.solutionStep.restricted);
        this.dealer = serviceRequest.order.user;
        this.replyItem = this.serviceRequest.reply.replyItems[this.Index];
        this.packagingLabel.deliveryDealer = this.dealer;
        this.packagingLabel.replyItem = this.replyItem.id;
        if (this.replyItem.replyPackagingLabel && this.replyItem.replyPackagingLabel.packagingLabel) {
          this.packagingLabel = this.replyItem.replyPackagingLabel.packagingLabel;
        }
      }
    });
  }

  openGenerateModal() {
    this.generateModal.showDialog();
  }

  updatePackagingLabel(event) {
    this.packagingLabel = event;
    this.replyItem.packagingLabel = this.packagingLabel;
    this.replyItem.isDone = true;
    this.serviceRequest.reply.replyItems[this.Index] = this.replyItem;
    this.confirmStep();
  }

  confirmStep() {
    this.requestService.autoStep({
      serviceRequest: this.serviceRequest.id,
    }).subscribe(res => {
      this.requestService.fetchServiceRequestComplete(this.serviceRequest.id, false);
    });
  }

  openPdfFile() {
    if (this.packagingLabel && this.packagingLabel.labelFile) {
      const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
      el.setAttribute('href', this.baseUrl + '/download?path='
        + this.packagingLabel.labelFile.path + '&filename=' + this.packagingLabel.labelFile.filename);
      el.setAttribute('download', this.baseUrl + '/download?path=' + this.packagingLabel.labelFile.filename);
      el.click();
    }
  }
}
